<template>
  <div class="main-container instalation-table-height">
    <div style="width: 100%;">
      <el-input
        style="max-width: 200px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="columns"
        :rows="deviceRequests"
        :search-options="{enabled: true,
                externalQuery: searchTerm}"
        :pagination-options="{enabled: true}"
        :lineNumbers="true"
      >
        <!-- styleClass="table table-striped col-md-12" -->
        <template slot="table-row" slot-scope="props">
          <!-- {{props.row}} -->
          <span
            v-if="props.column.field == 'full_name'"
          >{{ props.row.user? `${props.row.user['firstName'] } ${ props.row.user['lastName']}`:'--' }}</span>
          <span
            v-if="props.column.field == 'installation_name'"
          >{{props.row['installationName'] ? `${props.row['installationName'] } ` : `${props.row.user['firstName'] } ${ props.row.user['lastName']}` }}</span>

          <span
            v-if="props.column.field == 'email'"
          >{{ props.row.user? `${props.row.user['email'] } ` :'--' }}</span>
          <span
            v-if="props.column.field == 'user.phone'"
          >{{ props.row.user? `${props.row.user['phoneNumber'] } ` :'--' }}</span>
          <span
            v-if="props.column.field == 'deviceType.name'"
          >{{ props.row.deviceType? `${props.row.deviceType['name'] } ` :'--' }}</span>
          <span
            v-if="props.column.field == 'gender'"
          >{{(props.row.gender+"" === "0")?'Female':'Male'}}</span>
          <span v-else>{{props.row[props.column.field]}}</span>
          <span v-if="props.column.field == 'actions'" class="fancy">
            <can I="manage" a="installation">
              <!-- @click="scheduleInstalation(props.row)" -->
              <!-- <b-button
                  size="md"
                  variant="info"
                  style="margin-top: 12px;"
                  v-show="props.row.status == 2"
                >
                  Inventory Request
                  <span class="fa fa-calendar"></span>
              </b-button>-->
              <router-link
                v-show="props.row.status == 2"
                :to="`/instalation/schedule/${props.row.id}`"
              >
                <b-button size="md" variant="info" style="margin-top: 12px;">
                  Inventory Request & Installation Schedule&nbsp;
                  <span class="fa fa-calendar"></span>
                </b-button>
              </router-link>
            </can>
          </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Autocomplete from "../../utils/Autocomplete";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Autocomplete
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchTerm: "",
      componentId: null,
      componentTypeId: null,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null
      },
      deviceRequests: [],
      componentOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component"
        }
      ],
      componentTypeOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component type"
        }
      ],
      dataParams: {
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        comment: null,
        createAt: null,
        deviceType: null,
        user: null
      },
      columns: [
        {
          label: "Customer Name",
          field: "full_name"
        },
        {
          label: "Installation Name",
          field: "installation_name",
          filterable: true
        },
        {
          label: "Phone Number",
          field: "user.phone",
          filterable: true
        },

        // {
        //   label: 'Installation Address',
        //   field: 'address',
        //   filterable: true,
        // },
        {
          label: "Desired Bundle",
          field: "deviceType.name",
          filterable: true
        },
        {
          label: "Actions",
          field: "actions"
        }
      ],
      rows: [],
      reqSuccess: false
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ])
  },
  methods: {
    validateRequestForm() {
      for (let [field, value] of Object.entries(this.requestForm)) {
        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
      return true;
    },
    scheduleInstalation(installationObj) {
      this.$router.push({
        name: "instalationSchedule",
        params: {
          Installation: installationObj
        }
      });
    },
    fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/components/${selectedCompId}/componentTypes`;
        HTTP.get(url)
          .then(response => {
            const componentList = response.data;
            componentList.filter(x => {
              x.value = x.id;
              x.text = x.name;
            });
            componentList.unshift({
              value: null,
              disabled: true,
              text: "Please component type"
            });

            context.componentTypeOptions = componentList;
            context.componentTypeId = null;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    },
    fetchComponents() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get("/components/", {})
        .then(components => {
          const componentFetch = components.data;
          componentFetch.filter(x => {
            x.value = x.id;
            x.text = x.name;
          });

          componentFetch.unshift({
            value: null,
            disabled: true,
            text: "Select Component"
          });
          container.componentOptions = componentFetch;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    formatDate(date) {
      var date = new Date(date); //or your date here
      return (
        date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate()
      );
    },
    formatTime(date) {
      var date = new Date(date); //or your date here
      return (
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
      );
    },
    fetchData(d) {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get(
        `/device_requests/?filter={"include": ["user","deviceType"]}`,
        {}
      ).then(components => {
        const componentFetch = components.data;
        this.dataParams = componentFetch;
      });
    }
  },
  mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
    const HTTP = this.$httpUtils.instance;
    const container = this;
    HTTP.get(
      `/device_requests/?filter={"include": ["user","deviceType","installationComponents"], "where": {"status": 2}, "order": "id DESC" }`,
      {}
    ).then(rolesdata => {
      // console.log(JSON.stringify(rolesdata.data))
      container.deviceRequests = rolesdata.data;
    });
  }
};
</script>

<style>
.section-container {
  border-radius: 7px;
  background: #fff;
  -webkit-box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  margin-bottom: 1.875rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

.p-trial-period-expired__upgrade .form-group {
  width: 100%;
}

.custom-control-description {
  margin-left: 12px;
}

#__BVID__36___BV_label_,
#__BVID__40___BV_label_ {
  font-size: 13px !important;
}

.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  color: #269af1;
  /* height: 100px; */
}

.custom-modal__body {
  padding: 40px;
  text-align: left;
}

.test-basic__format {
  font-size: 16px;
  color: #939daa;
}

.test-basic__format span {
  font-weight: 800;
  color: #269af1;
}

.fancy a {
  color: #424242 !important;
}
.instalation-table-height {
  height: calc(100vh - 280px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/instalation/instalationList.vue